import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {BaseComponent, TemplateFeature} from 'compob2b-libs';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {
  TemplateFeatureService,
  TemplateFeatureValue
} from '../../../../../../compob2b-admin/src/app/cabinet/pim/product/create-update/features/template-feature.service'

import {NbButtonModule, NbTooltipModule} from '@nebular/theme';
import {
  ThreeStateCheckboxComponent
} from '../../../../../../compob2b-admin/src/app/admin-shared/custom-form-types/three-state-checkbox/three-state-checkbox.component';
import {RouterLink} from '@angular/router';
import {TuiIcon} from '@taiga-ui/core'

@Component({
  selector: 'app-tf-boolean',
  templateUrl: './tf-boolean.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbButtonModule, NbTooltipModule, FormsModule, ReactiveFormsModule, ThreeStateCheckboxComponent, RouterLink, TuiIcon]
})
export class TfBooleanComponent extends BaseComponent implements OnInit {
  @Input() feature: TemplateFeature;
  @Input() featureLink = false;
  @Input() showRemoveButton = false;
  @Output() removeEvent = new EventEmitter<void>();

  form = new UntypedFormGroup({
    featureValue: new UntypedFormControl(false)
  });

  templateFeatureService = inject(TemplateFeatureService);

  ngOnInit(): void {
    this.form.get('featureValue').valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.unsubscribe),
      )
      .subscribe(data => {
        this.setFeature(JSON.parse(String(data)), this.form.valid, this.isShowEmptyWarning());
        this.cdr.detectChanges();
      });

    this.setDefaultValue();

    this.templateFeatureService.isFeaturesModelReloaded()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(_ => {
        this.setDefaultValue();
        this.cdr.detectChanges();
      });
  }

  private setDefaultValue(): void {
    const featureModel = this.templateFeatureService.getFeatureModel();

    if (this.feature.id in featureModel) {
      const val = featureModel[this.feature.id];
      this.featureValue.setValue(val, {emitEvent: false});
    }

    this.setDefaultFeatureValue(
      this.featureValue.value === null ? null : JSON.parse(this.featureValue.value)
    );
  }

  private setFeature(featureValue: TemplateFeatureValue, valid: boolean, empty: boolean): void {
    this.templateFeatureService.setFeature(
      this.feature.groupId,
      this.feature.id,
      featureValue,
      valid,
      empty
    );
  }

  private setDefaultFeatureValue(featureValue: TemplateFeatureValue): void {
    this.templateFeatureService.setDefaultFeatureValue(
      this.feature.groupId,
      this.feature.id,
      featureValue,
      this.form.valid,
      this.isShowEmptyWarning()
    );
  }

  isEmpty(): boolean {
    return ![true, false].includes(this.featureValue.value);
  }

  isRequired(): boolean {
    return this.feature.required;
  }

  isShowEmptyWarning(): boolean {
    return this.isRequired() && this.isEmpty();
  }

  get featureValue(): any {
    return this.form.get('featureValue');
  }
}
